export const ADMIN_ROUTE = '/admin'
export const SHOP_ROUTE = '/'
export const PROFILE_ROUTE = '/profile'
export const ADD_ROUTE = '/add'
export const FAVOURITES_ROUTE = '/favourites'
export const CREATE_ADD = '/createAdd'
export const USER_ROUTE = '/user'
export const MAIN_ROUTE = '/main'
export const BLOG_ROUTE = '/blog'
export const ABOUT_US_ROUTE = '/about'
export const PHOTO_GALLERY_ROUTE = '/photo_gallery'
export const PLACES_ROUTE = '/places'
export const ADD_CHECKED_ROUTE = '/checked'
export const MESSAGE_ROUTE = '/messages'
export const GLOBAL_REVIEWS_ROUTE = '/global_reviews'
export const EDIT_ADD_ROUTE = '/editAdd'
export const CHAT_ROUTE = '/chat'
export const SELECTION_CREATE_ROUTE = '/selection/create'
export const SELECTION_VIEW_ROUTE = '/v'
export const OWNER_ANALYTICS_ROUTE = '/owner_analytics';
export const ADMIN_ANALYTICS_ROUTE = '/admin_analytics';
export const MAP_SEARCH_ROUTE = '/map_search';
export const ADMIN_AREA_EDITOR_ROUTE = '/admin/areas/editor'
export const ADMIN_ROUTE_DEBUG_ROUTE = '/admin/routes/debug';
export const ADMIN_CHATS_ROUTE = '/admin/chats';
export const PROMOTION_ROUTE = '/promotion'
export const OWNER_PROMOTIONS_ROUTE = '/owner_promotions';
export const PAYMENT_RETURN_ROUTE = '/payment/return';
export const REQUEST_CHAT_ROUTE = '/requestChat';
export const DIRECT_CHATS_ROUTE = '/direct';
export const REQUEST_OFFER_CREATE_ROUTE = `${REQUEST_CHAT_ROUTE}/offer`;
export const OWNER_REQUESTS_ROUTE = '/owner/requests';
export const OWNER_BOOKINGS_ROUTE = '/owner/bookings';
// Hidden developer-only browser test; route is not registered in production.
export const BOOKING_BROWSER_TEST_ROUTE = '/dev/booking-test';
export const OWNER_RESULTS_ROUTE = '/owner/results';
export const ADMIN_REQUESTS_ROUTE = '/admin/requests';
export const SEO_LANDING_ROUTE = '/:slug';
export const ADMIN_GEO_ROUTE = '/admin/geo';
export const ADMIN_REVIEWS_ROUTE = '/admin/reviews';
export const OWNER_CALENDAR_ROUTE = '/owner/calendar';
export const ADMIN_CALENDAR_SNAPSHOTS_ROUTE = '/admin/calendar/snapshots';
export const ADMIN_CALENDAR_CONNECTIONS_ROUTE = '/admin/calendar/connections';
export const OWNER_CALENDARS_ROUTE = '/my-calendars';
export const NOTIFICATIONS_SETUP_ROUTE = "/notifications/setup"
export const BROWSER_HANDOFF_ROUTE = '/browser-handoff';
export const APP_START_ROUTE = '/app-start';
export const LEGACY_PHONE_TRANSFER_ROUTE = '/account/transfer';

export const AVITO_CALLBACK_ROUTE = "/integrations/avito/callback";
